export default "__VITE_ASSET__CYhZCN5N__"